import React, {useState, useRef, useEffect} from "react";

import {
    TwitterShareButton,
    FacebookShareButton,
    EmailShareButton,
    WhatsappShareButton,
    FacebookIcon,
    TwitterIcon,
    EmailIcon,
    WhatsappIcon,
  } from "react-share";

export default function Share(props) {
  const url = props.src
  return (
    <div 
    style={{
      color: "white",
      backgroundColor: "black",
      textAlign: "left",
      overflow: "hidden",
      padding: props.isMobile? "5px 2vw 10px 10vw":"5px 25vw 10px 25vw",
    }}>
        <div>
        <FacebookShareButton
          url={url}
          quote={"'Waiting to happen' - the cascading failures that helped ISIS escape a US-backed prison"}
          >
          <FacebookIcon size={32} round />
        </FacebookShareButton>
        <TwitterShareButton
          title={"'Waiting to happen' - the cascading failures that helped ISIS escape a US-backed prison"}
          via ={'Airwars'}
          url={url}
          >
          <TwitterIcon size={32} round />
        </TwitterShareButton>
        <EmailShareButton
          url={url}
          subject={"'Waiting to happen' - the cascading failures that helped ISIS escape a US-backed prison"}
          >
          <EmailIcon size={32} round />
        </EmailShareButton>
        <WhatsappShareButton
          title={"'Waiting to happen' - the cascading failures that helped ISIS escape a US-backed prison"}
          url={url}
          >
          <WhatsappIcon size={32} round />
        </WhatsappShareButton>
        </div>
  </div>

)}